import { inject, Pipe, PipeTransform } from '@angular/core';
import { appendToRmaBaseUrl } from '@rma/generic/ng/util';

@Pipe({
  name: 'baseUrl',
  standalone: true,
})
export class BaseUrlPipe implements PipeTransform {
  private readonly rmaBaseUrl = inject(appendToRmaBaseUrl);

  transform(value: string): string {
    return this.rmaBaseUrl(value);
  }
}
